// Points and badges for the staff scoreboard. Used by Leads (where points are earned)
// and My settings (where they're shown). Change them here and both pages follow.
export const POINTS = { lead: 10, call: 5, email: 3, meeting: 10, qualified: 8, proposal: 12, won: 50 };

export const BADGES = [
  { name: "First lead", min: 10 },
  { name: "Prospector", min: 100 },
  { name: "Connector", min: 250 },
  { name: "Closer", min: 500 },
  { name: "City builder", min: 1000 },
];

// Same day format user_stats.dayKey uses.
export function dayKey(d = new Date()) {
  return d.toISOString().slice(0, 10);
}